import { Card } from "../../CRUDs/entities/Card";
import { BankAccount } from "../../CRUDs/entities/BankAccount";
import { CardForm } from "../../Common/Forms/CardForm";
import { checkActionAttribute } from "./checkActionAttribute";

export const paymethodsModalActionsListners = (target, actionsWindow) => {

    actionsWindow.find('.action').off();

    const paymentMethodId = target.parent().data('id');
    const paymentMethodType = target.parent().data('method-type');
    let paymentMethod;

    if (paymentMethodType == 'card') {
        paymentMethod = new Card(paymentMethodId);
    } else if (paymentMethodType == 'bank_account') {
        paymentMethod = new BankAccount(paymentMethodId);
    }

    checkActionAttribute([
        { attribute: 'data-not-primary',    className: 'set-primary' },
        { attribute: 'data-not-backup',     className: 'set-backup' },
        { attribute: 'data-not-delete',     className: 'delete' },
        { attribute: 'data-not-verified',   className: 'verify' },
    ], target, actionsWindow);

    // delete
    actionsWindow.find('.action.delete').on('click', (e) => {
        paymentMethod.delete().then(response=>{
            if(response){
                if(response?.ok) window.location.reload()
                else console.error(response)
            }
        });
        actionsWindow.addClass('d-none').removeClass('d-flex');
    });

    // update
    actionsWindow.find('.action.update').on('click', (e) => {
        paymentMethod.openModal('edit');
        if (paymentMethodType == 'card') new CardForm(paymentMethod, 'edit');
    });

    // set as primary
    actionsWindow.find('.action.set-primary').on('click', (e) => {
        paymentMethod.setAsPrimary();
    });

    // set as backup
    actionsWindow.find('.action.set-backup').on('click', (e) => {
        paymentMethod.setAsBackup();
    });

    // verify
    actionsWindow.find('.action.verify').on('click', (e) => {
        if (target.parents('.data-row')[0].hasAttribute('data-processing')) paymentMethod.manuallyVerificationStart();
        else paymentMethod.agreementVerificationForm();
    });
}
